import * as _ from 'lodash-es';
import { AdminClientsList } from "../model/adminClients-list";
import { AdminClient } from "../model/adminClient";
import { VehicleBuilder } from "./vehicle-builder";
import { AdminInvoiceProfileBuilder } from "./adminInvoiceProfile-builder";
import { AdminPaymethodBuilder } from "./adminPaymethod-builder";
import { AdminClientTrackingBuilder } from './adminClientTracking-builder';
import { ClientNote } from '../model/clientNote';
export class AdminClientBuilder {
    static buildAdminClient(data) {
        let adminClient = new AdminClient();
        adminClient.id = data.id;
        adminClient.email = data.email;
        adminClient.name = data.name;
        adminClient.last_name = data.last_name;
        adminClient.phone = data.phone;
        adminClient.zip = data.zip;
        adminClient.id_default_invoice_profile = data.id_default_invoice_profile;
        adminClient.lang = data.lang;
        adminClient.accept_promos = data.accept_promos;
        adminClient.accept_newsletter = data.accept_newsletter;
        adminClient.active = data.active;
        adminClient.invoice_requested = data.invoice_requested;
        adminClient.date_register = data.date_register;
        adminClient.points_used = data.points_used;
        adminClient.aena = data.aena;
        adminClient.dto_lot = data.dto_lot;
        adminClient.emtrics = data.emtrics;
        adminClient.auth_id_facebook = data.auth_id_facebook;
        adminClient.auth_id_google = data.auth_id_google;
        adminClient.password_recovery_hash = data.password_recovery_hash;
        adminClient.PRIMARY = data.PRIMARY;
        adminClient.password = data.password;
        adminClient.password_recovery_date = data.password_recovery_date;
        adminClient.date_modified = data.date_modified;
        adminClient.date_last_login = data.date_last_login;
        adminClient.push_platform = data.push_platform;
        adminClient.push_token = data.push_token;
        adminClient.push_token_timestamp = data.push_token_timestamp;
        adminClient.app_version = data.app_version;
        adminClient.app_platform = data.app_platform;
        adminClient.app_rated = data.app_rated;
        adminClient.app_rated_timestamp = data.app_rated_timestamp;
        adminClient.email_confirmed = data.email_confirmed;
        adminClient.phone_confirmed = data.phone_confirmed;
        adminClient.client_tracking = data.client_tracking ? AdminClientTrackingBuilder.buildAdminClientTracking(data.client_tracking) : null;
        adminClient.points_available = data.points_available;
        adminClient.vehicles = _.map(data.vehicles, (vehicle) => {
            return VehicleBuilder.buildVehicle(vehicle);
        });
        adminClient.invoice_profiles = _.map(data.invoice_profiles, (invoiceProfile) => {
            return AdminInvoiceProfileBuilder.buildAdminInvoiceProfile(invoiceProfile);
        });
        adminClient.paymethods = _.map(data.paymethods, (paymethod) => {
            return AdminPaymethodBuilder.buildAdminPaymethod(paymethod);
        });
        adminClient.notes = _.map(data.notes, (notes) => {
            return this.buildClientNote(notes);
        });
        return adminClient;
    }
    static buildClientNote(data) {
        const note = new ClientNote();
        note.id_user = data.id_user;
        note.id_client = data.id_client;
        note.date_created = data.date_created;
        note.body = data.body;
        note.id = data.id;
        note.user_alias = data.user_alias;
        return note;
    }
    static buildAdminClientsList(data) {
        const adminClientsList = new AdminClientsList();
        adminClientsList.page = data.page;
        adminClientsList.totalCount = data.total;
        adminClientsList.pagination = data.pagination;
        adminClientsList.clients = _.map(data.clients, (adminClient) => {
            return AdminClientBuilder.buildAdminClient(adminClient);
        });
        return adminClientsList;
    }
}
//# sourceMappingURL=adminClient-builder.js.map